"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("@upflowy/types");
const constants_1 = require("./constants");
const helper_1 = require("./helper");
const nodeFactory = {
    conditional({ cond, name, nodeId, joinNodeId, paths, }) {
        const id = nodeId !== null && nodeId !== void 0 ? nodeId : (0, helper_1.shortUuid)();
        return {
            type: 'condNode',
            id,
            paths: paths !== null && paths !== void 0 ? paths : [
                {
                    path: [],
                    cond,
                    name,
                    id: (0, helper_1.shortUuid)(),
                },
                {
                    path: [],
                    name: constants_1.CONDITIONAL_SPLIT_ELSE,
                    id: (0, helper_1.shortUuid)(),
                },
            ],
            splitNode: id,
            joinNode: joinNodeId !== null && joinNodeId !== void 0 ? joinNodeId : (0, helper_1.shortUuid)(),
        };
    },
    ab({ name, nodeId, joinNodeId, paths, variations, }) {
        const id = nodeId !== null && nodeId !== void 0 ? nodeId : (0, helper_1.shortUuid)();
        return {
            type: 'abTestNode',
            id,
            paths: paths !== null && paths !== void 0 ? paths : [],
            name: name !== null && name !== void 0 ? name : 'A/B Test',
            variations: variations !== null && variations !== void 0 ? variations : [],
            splitNode: id,
            joinNode: joinNodeId !== null && joinNodeId !== void 0 ? joinNodeId : (0, helper_1.shortUuid)(),
        };
    },
    step({ stepId }) {
        return {
            type: 'stepNode',
            id: stepId,
            config: {
                stepId,
            },
        };
    },
    end() {
        return {
            type: 'endNode',
            id: (0, helper_1.shortUuid)(),
        };
    },
    origin() {
        return {
            type: 'externalNode',
            id: types_1.ORIGIN_STATE_ID,
        };
    },
};
exports.default = nodeFactory;
//# sourceMappingURL=node-factory.js.map